import {Provider} from '@angular/core';

import {SWIPER_CONFIG, SwiperConfig, SwiperConfigInterface} from 'ngx-swiper-wrapper';
import {SwiperConfiguration} from '../config/swiper.config';

export const useFactory: () => SwiperConfigInterface = () => {
    // extend the default swiper config with ours
    return Object.assign({}, SwiperConfig, SwiperConfiguration);
};

export const SWIPER_PROVIDERS: Provider[] = [
    {
        provide: SWIPER_CONFIG,
        useFactory
    }
];
